import { connect } from "react-redux";
import ColoredDiamondFilter from "./ColoredDiamondFilter.component";
import React, { PureComponent } from "react";

/** @namespace Route/MenuPage/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    device: state.ConfigReducer.device,
});

export class ColoredDiamondFilterContainer extends PureComponent {
    static propTypes = {
        renderGetDiamond: this.propTypes,
        device: this.propTypes
    }

    containerProps() {
        const { renderGetDiamond, device } = this.props;

        return {
            renderGetDiamond,
            device
        };
    }

    render() {
        return (
            <ColoredDiamondFilter
                {...this.containerProps()}
            />
        );
    }
}

export default connect(mapStateToProps)(ColoredDiamondFilterContainer);
